import { emulatorScreen, mobileScreen } from "../../../../utils/styleUtils";

const styles = (theme) => ({
  verticalLinesContainer: {
    position: "absolute",
    top: "-52px",
    left: "225px",
    [emulatorScreen(theme)]: {
      top: "-35px",
      left: "150px",
    },
    [mobileScreen(theme)]: {
      top: "-25px",
      left: "100px",
    },
  },

  graphLines: {
    borderLeft: "5px solid #565656",
    borderBottom: "5px solid #565656",
    height: "330px",
    width: "460px",
    position: "relative",
    [emulatorScreen(theme)]: {
      width: "290px",
      height: "210px",
      borderWidth: "3px",
    },
    [mobileScreen(theme)]: {
      width: "200px",
      height: "150px",
      borderWidth: "3px",
    },
  },

  graphYLable: {
    height: "18px",
    position: "absolute",
    top: "7px",
    left: "-90px",
    [emulatorScreen(theme)]: {
      height: "12px",
      left: "-60px",
    },
    [mobileScreen(theme)]: {
      height: "10px",
      left: "-50px",
    },
  },

  graphXLable: {
    height: "18px",
    position: "absolute",
    bottom: "-35px",
    right: "5px",
    [emulatorScreen(theme)]: {
      height: "12px",
      bottom: "-25px",
    },
    [mobileScreen(theme)]: {
      height: "10px",
      bottom: "-22px",
    },
  },

  dragLineMessage: {
    height: "130px",
    position: "absolute",
    right: "-20px",
    top: "80px",
    [emulatorScreen(theme)]: {
      height: "90px",
      right: "-25px",
      top: "50px",
    },
    [mobileScreen(theme)]: {
      top: "25px",
      right: "-25px",
      height: "75px",
    },
  },

  questionMark: {
    width: "150px",
    [emulatorScreen(theme)]: {
      width: "95px",
    },
    [mobileScreen(theme)]: {
      width: "85px",
    },
  },

  arrows: {
    position: "absolute",
    height: "30px",
    top: "185px",
    left: "-50px",
    [emulatorScreen(theme)]: {
      top: "117px",
      left: "12px",
      height: "18px",
    },
    [mobileScreen(theme)]: {
      top: "84px",
      left: "8px",
      height: "10px",
    },
  },

  defaultLine: {
    transform: "rotate(-45deg)",
    position: "absolute",
    height: "400px",
    width: "8px",
    backgroundColor: "#003e4c",
    borderRadius: "5px",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  correctLine: {
    transform: "rotate(-45deg)",
    position: "absolute",
    height: "400px",
    width: "8px",
    borderRadius: "5px",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  dragableLine: {
    display: "flex",
    justifyContent: "center",
    height: "400px",
    width: "6px",
    position: "relative",
    borderRadius: "5px",
    transform: "rotate(-45deg)",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  dragableLineContainer: {
    display: "flex",
    justifyContent: "center",
    width: "6px",
    position: "relative",
    borderRadius: "5px",
    transform: "rotate(-45deg)",
    top: "28px",
    left: "-68px",
    height: "0",
    position: "absolute",
    // [emulatorScreen(theme)]: {
    //   height: "260px",
    //   width: "5px",
    // },
    // [mobileScreen(theme)]: {
    //   height: "190px",
    //   width: "4px"
    // },
  },

  fadedDot: {
    position: "absolute",
    transform: "rotate(45deg)",
    border: "5px solid #003E4C",
    borderRadius: "50%",
    padding: "10px",
    backgroundColor: "#003E4C",
    top: "120px",
    color: "blue",
    [emulatorScreen(theme)]: {
      padding: "7px",
      borderWidth: "4px",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      borderWidth: "4px",
    },
  },

  correctDot: {
    position: "absolute",
    transform: "rotate(45deg)",
    border: "5px solid #003e4c",
    borderRadius: "50%",
    padding: "10px",
    backgroundColor: "#CACDCE",
    color: "blue",
    zindex: 100,
    // border: "5px solid",
    [emulatorScreen(theme)]: {
      padding: "7px",
      border: "4px solid #003e4c",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      border: "4px solid #003e4c",
    },
  },

  draggableDot: {
    transform: "rotate(45deg)",
    borderRadius: "50%",
    padding: "10px",
    color: "blue",
    border: "5px solid",
    [emulatorScreen(theme)]: {
      padding: "7px",
      border: "4px solid",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      border: "4px solid",
    },
  },

  domasticContainer: {
    justifyContent: "center",
    position: "relative",
    display: "flex",

    [emulatorScreen(theme)]: {
      justifyContent: "start",
    },
    [mobileScreen(theme)]: {
      justifyContent: "start",
    },
  },

  //new design

  innerContainer: {
    position: "relative",
    display: "flex",
    height: 400,
    width: 400,
    [emulatorScreen(theme)]: {
      height: 250,
      width: 250,
    },
    [mobileScreen(theme)]: {
      height: 250,
      width: 250,
    },
  },

  horWhite: {
    position: "absolute",
    top: 179,
    width: "55%",
    left: 77,
    [emulatorScreen(theme)]: {
      top: 111,
      left: 47,
    },
    [mobileScreen(theme)]: {
      top: 112,
      left: 47,
    },
  },
  HorBlue: {
    position: "absolute",
    top: 179,
    width: "55%",
    left: 77,
    [emulatorScreen(theme)]: {
      top: 111,
      left: 47,
    },
    [mobileScreen(theme)]: {
      top: 112,
      left: 47,
    },
  },
  HorGreen: {
    position: "absolute",
    top: 188,
    width: "46.5%",
    left: 111,
    [emulatorScreen(theme)]: {
      top: 118,
      left: 69,
    },
    [mobileScreen(theme)]: {
      top: 118,
      left: 69,
    },
  },
  HorRed: {
    height: "1%",
    position: "absolute",
    top: 189,
    width: "46%",
    left: 111,
    [emulatorScreen(theme)]: {
      height: "2%",
      top: 116,
      left: 69,
    },
    [mobileScreen(theme)]: {
      top: 118,
      left: 69,
    },
  },

  VertWhite: {
    height: "41%",
    top: 195,
    right: 89,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 121,
      left: 180,
    },
    [mobileScreen(theme)]: {
      top: 121,
      left: 180,
    },
  },
  VertBlue: {
    height: "41%",
    top: 195,
    right: 89.45,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 121,
      left: 179.7,
    },
    [mobileScreen(theme)]: {
      top: 121,
      left: 180,
    },
  },

  VertGreen: {},

  VertRed: {
    height: "34%",
    top: 195,
    right: 98,
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "35%",
      top: 121,
      left: 174,
      width: 28,
    },
    [mobileScreen(theme)]: {
      // height: "35%",
      top: 121,
      left: 174,
      width: 28,
    },
  },

  //triangles
  TopRight: {
    width: 378,
    overflow: "hidden",
    top: 46,
    left: "27.8%",
    position: "absolute",
    zIndex: 3,
    [emulatorScreen(theme)]: {
      width: 236,
      top: 28,
      left: "27.7%",
    },
    [mobileScreen(theme)]: {
      width: 236,
      top: 28,
      left: "27.5%",
    },
  },

  Triangle1: {
    float: "left",
    height: 136,
    clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
    width: 182,
    marginTop: 7,
    [emulatorScreen(theme)]: {
      width: 115,
      height: 86.1,
      marginTop: 4,
    },
    [mobileScreen(theme)]: {
      width: 115,
      height: 86.1,
      marginTop: 4,
    },
  },

  Triangle2: {
    float: "left",
    height: "99%",
    clipPath: "polygon(100% 0, 0 0, 50% 50%)",
    shapeOutside: "polygon(100% 0, 0 0, 50% 50%)",
    width: "99%",
    position: "absolute",
    left: 2,
    [emulatorScreen(theme)]: {
      width: "99.4%",
      height: "98.2%",
      left: "0.8%",
      top: 1,
      clipPath: "polygon(100% 0%, 0 0.4%, 50% 50%)",
      shapeOutside: "polygon(100% 0%, 0 0.4%, 50% 50%)",
    },
    [mobileScreen(theme)]: {
      width: "99%",
      height: "98.2%",
      left: "1%",
      clipPath: "polygon(100% 0.6%, 0 0.4%, 50% 50%)",
      shapeOutside: "polygon(100% 0.6%, 0 0.4%, 50% 50%)",
    },
  },

  Triangle3: {
    float: "left",
    height: 135.5,
    marginTop: 6.5,
    marginLeft: "50.36%",
    clipPath: "polygon(0 0, 100% 100%, 0 100%)",
    shapeOutside: "polygon(0 0, 100% 100%, 0 100%)",
    width: 183,
    [emulatorScreen(theme)]: {
      height: 86,
      width: 114,
      marginTop: 3.5,
      marginLeft: "50.8%",
    },
    [mobileScreen(theme)]: {
      height: 85,
      width: 114,
      marginTop: 3.5,
      marginLeft: "50.8%",
    },
  },

  Triangle4: {
    float: "left",
    height: "99%",
    clipPath: "polygon(100% 100%, 100% 0, 50% 50%)",
    shapeOutside: "polygon(100% 100%, 100% 0, 50% 50%)",
    width: "99.9%",
    position: "absolute",
    top: 3,
    left: 6,
    [emulatorScreen(theme)]: {
      height: "99%",
      width: "100%",
      top: 2,
      left: 4,
    },
    [mobileScreen(theme)]: {
      height: "99%",
      width: "100%",
      top: 2,
      left: 4,
    },
  },

  bottomLeft: {
    width: 186.5,
    height: 140,
    overflow: "hidden",
    top: 192.5,
    left: 111,
    position: "absolute",
    zIndex: 3,
    [emulatorScreen(theme)]: {
      height: 87,
      width: 118,
      top: 120,
      left: 69,
    },
    [mobileScreen(theme)]: {
      height: 87,
      width: 118,
      top: 120,
      left: 69,
    },
  },

  Triangle5: {
    float: "left",
    height: 136,
    clipPath: "polygon(100% 0, 0 0, 0 100%)",
    shapeOutside: "polygon(100% 0, 0 0, 0 100%)",
    width: 182,
    marginLeft: 0.5,
    [emulatorScreen(theme)]: {
      clipPath: "polygon(101% 0, 0 0, 0 100%)",
      width: "96%",
      height: "99%",
    },
    [mobileScreen(theme)]: {
      width: "96%",
      height: "98%",
    },
  },

  Triangle6: {
    float: "left",
    height: 134,
    clipPath: "polygon(100% 0, 100% 100%, 0 100%)",
    shapeOutside: "polygon(100% 0, 100% 100%, 0 100%)",
    width: 180,
    position: "absolute",
    left: "4%",
    top: 4,
    [emulatorScreen(theme)]: {
      width: "97%",
      height: "98%",
      left: "2.8%",
      top: 2,
    },
    [mobileScreen(theme)]: {
      width: "97%",
      height: "98%",
      left: "2.8%",
      top: 2,
    },
  },
});
export default styles;
